module.exports = __webpack_public_path__ + "media/img/event/speakers/Dr-Don-Hong-dc18bbba6e54c792b3670e8bcc1f628f.jpg";